import { GenericResponse } from 'services/api/base';

export interface RawFileListFile {
  type: 'F';
  id: string;
  size: number;
  name: string;
  extension: string;
  modified: number;
}
export interface RawFileListDirectory {
  id: string;
  type: 'D';
  name: string;
  children: {
    [key: string]: RawFileListDirectory | RawFileListFile;
  }
}
export type RawFileListEntry = RawFileListDirectory | RawFileListFile;
export interface RawFileList {
  [key: string]: RawFileListDirectory;
}
export type FileListResponse = GenericResponse<RawFileList>;

export interface FileListFile {
  label: string;
  type: 'F';
  id: string;
  size: number;
  name: string;
  extension: string;
  modified: number;
}
export interface FileListDirectory {
  label: string;
  id: string;
  type: 'D';
  name: string;
  children: (FileListDirectory | FileListFile)[];
}
export type FileListEntry = FileListDirectory | FileListFile;
export type FileList = FileListEntry[];

/** Argumentos de `getFileList`; `{}` é a lista de hoje (a visão da própria empresa). */
export interface FileListArgs {
  /**
   * Admin (`empresa.parte`): restringe a árvore ao que os usuários dessa empresa veem. Só vai na
   * URL quando é inteiro positivo; para não-admin o backend ignora.
   */
  empresa?: number;
  /** Admin: pede ao backend para reler o disco (`refresh=1`). Fica fora da chave do cache. */
  refresh?: boolean;
}

/** Escopo do filtro Empresa de Meus Arquivos: a própria visão ou uma empresa escolhida. */
export type CompanyScope = 'todas' | { companyId: number };

/** Item de `RawFileViewerCompanies.itens`. */
export interface RawFileViewerCompany {
  id: number;
  nome: string;
  /** Pode vir anonimizado no QA (`apelido_-_75`). */
  apelido?: string | null;
  /** Pastas-raiz que a empresa recebe (pode ser 0). Não existe contagem de arquivos. */
  total_pastas?: number | null;
}

/** `data` de `GET produtos/file-viewer/empresas/` (não-admin: `itens: []` e total 0). */
export interface RawFileViewerCompanies {
  total_empresas: number;
  itens: RawFileViewerCompany[];
}
export type FileViewerCompaniesResponse = GenericResponse<RawFileViewerCompanies>;

export interface FileViewerCompanyOption {
  id: number;
  name: string;
  /** '' quando o backend não manda. */
  nickname: string;
  /** 0 quando o backend não manda. */
  folderCount: number;
}

/** Lista de empresas do filtro, já ordenada por nome, com o total de "Todas as empresas". */
export interface FileViewerCompanies {
  totalCompanies: number;
  options: FileViewerCompanyOption[];
}

export interface AddDirectoryParams {
  formattedPath: string;
}
export type AddDirectoryResponse = GenericResponse<null>;

export interface UploadFileParams {
  dirName: string;
  formattedPath: string;
  filename: string;
  fileBase64: string;
}
export type UploadFileResponse = GenericResponse<null>;

const transformRawFileListEntry = (entry: RawFileListEntry, label: string): FileListEntry => {
  if (entry.type === 'D') {
    const children = Object
      .entries(entry.children)
      .map(([l, e]) => transformRawFileListEntry(e, l));
    return { ...entry, label, children };
  }
  return { ...entry, label };
};

export const transformFileListReponse = (response: FileListResponse): FileList => (
  Object
    .entries(response.data)
    .map(([label, e]) => transformRawFileListEntry(e, label))
);
